import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';
import {sortBy} from 'lodash';
import {map} from 'rxjs/operators';

import {environment} from '../../../environments/environment';
import {D3TreeResponse} from '../d3/d3.interface';
import {RmnD3TreeData} from '../models/rmn-d3-tree-data.interface';

@Injectable({
  providedIn: 'root'
})
export class ImpactAssessmentDaoService extends BaseDaoService {
  constructor() {
    super();
  }

  fetchDependenciesChildren({
    refModelId,
    depRefModelId,
    internalRefModel,
    nodeId,
    nodeType,
    skip
  }: {
    refModelId: string;
    depRefModelId?: string;
    internalRefModel?: boolean;
    nodeId: string;
    nodeType: string;
    skip: number;
  }) {
    let params = new HttpParams().set('skip', String(skip));

    if (internalRefModel) {
      params = params
        .append('depRefModelId', depRefModelId)
        .append('internalRefModel', internalRefModel.toString());
    }

    return this.http
      .get<
        D3TreeResponse<RmnD3TreeData>
      >(`${environment.API_ENDPOINT}/refmodel/${refModelId}/node/${nodeId}/${nodeType}/dependents-tree`, {params})
      .pipe(map(({tree}) => this.processDependenciesItems(tree)));
  }

  fetchDependenciesDetails(refModelId: string, nodeId: string) {
    return this.http.get(
      `${environment.API_ENDPOINT}/refmodel/${refModelId}/node/${nodeId}/dependents-tree/details`
    );
  }

  processDependenciesItems(dependencies): {children: RmnD3TreeData[]} {
    const processedDependents = dependencies.dependents.items.map(child => {
      child.children = [];

      return child;
    });

    return {
      children: sortBy([...processedDependents], 'name')
    };
  }
}
